<script lang="ts">
    import { tgettext } from 'hydria/services/gettext'

    import { INFORMATION_PAGE_TYPES } from 'admin/admin_constants'

    import SimpleListingWithPagination from 'hydria/components/SimpleListings/SimpleListingWithPagination.svelte'

    const singular = 'jinja_template'
    const plural = 'jinja_templates'
    const baseUrl = '/jinja-templates'

    const pageTitle = tgettext('Modèles Jinja')
    const createButtonText = tgettext('Ajouter un modèle')

    const extraLgFields = [
        {
            id: 'filename',
            name: tgettext('Nom de fichier'),
            empty: '–',
        },
    ]

    interface Props {
        route: any
    }

    let { route }: Props = $props()
</script>

<SimpleListingWithPagination {route} {singular} {plural} {baseUrl} {pageTitle} {createButtonText} {extraLgFields} />
